import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Alert } from 'react-bootstrap'
import styled from 'styled-components'
import AppointmentTypesSelect from './AppointmentTypesSelect'
import useCabinTypesState from '../../../stores/Configuration/useCabinTypesState'
import { useLocation } from 'react-router'

const StyledButton = styled(Button)`
margin-top:1.5rem;
margin-bottom:1.5rem;
  @media screen and (max-width: 767px) {
      width:100%;
`
const AssignedAppointmentTypesForm = () => {
  const { t } = useTranslation()
  const location = useLocation()
  const { handleSubmit, error, success, setError, setSuccess } =
    useCabinTypesState()

  useEffect(() => {
    setError('')
    setSuccess('')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, location.hash])

  return (
    <>
      <AppointmentTypesSelect />
      {error && (
        <Alert variant='danger' className='mt-4 mb-0'>
          {error}
        </Alert>
      )}
      {success && (
        <Alert variant='success' className='mt-4 mb-0 '>
          {success}
        </Alert>
      )}
      <StyledButton
        className='btn-extra-padding'
        onClick={() => handleSubmit('assignedAppointmentTypes')}
      >
        {t('saveButton')}
      </StyledButton>
    </>
  )
}

export default AssignedAppointmentTypesForm
